module.exports = __webpack_public_path__ + "static/media/icon-cwb-nav-public.3ef11b7d.svg";